// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___ZDvC8","root__item":"style-module__root__item___m1k2X","root__number":"style-module__root__number___HGqD6","root__label":"style-module__root__label___tPB2W"};
    if(module.hot) {
      // 1729151133320
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  